import {
  FsSwiss,
  FsSwissSegment,
} from "db/model/tournament/Segment/Swiss/FsSwiss";
import { Swiss, SwissSegment } from "model/Tournament/Segment/Swiss/Swiss";
import { nonUndefined } from "Utility";
import { mapRoundsSegmentGroupBase } from "../FsRoundsSegmentGroup";
import { mapTournamentSegmentBase } from "../FsTournamentSegment";

export const mapSwissSegment = (
  fsModel: FsSwissSegment
): SwissSegment | undefined => {
  return mapTournamentSegmentBase(fsModel, fsModel.type, mapSwisses);
};

const mapSwisses = (fsModels: FsSwiss[]): Swiss[] => {
  return nonUndefined(fsModels.map(mapSwiss));
};

const mapSwiss = (fsModel: FsSwiss): Swiss | undefined => {
  return {
    ...mapRoundsSegmentGroupBase(fsModel),
  };
};
